<template>
  <div class="home">
    <v-carousel
      class="slideprincipal elevation-1 relative"
      cycle
      delimiter-icon="fas fa-minus"
      hide-delimiters
      show-arrows-on-hover
    >
      <template v-if="!slides.length">
        <v-carousel-item>
          <img class="carousel-img" src="/img/banner.png" />
        </v-carousel-item>
      </template>
      <template v-else>
        <v-carousel-item v-for="(s, i) in slides" :key="i">
          <img class="carousel-img" :src="files + s.img" />
        </v-carousel-item>
      </template>
    </v-carousel>

    <v-container>
      <template>
        <v-carousel hide-delimiters show-arrows-on-hover class="article">
          <v-carousel-item v-for="(article, i) in articlesok" :key="i">
            <section class="newsdiv">
              <template v-if="!articlesok.length">
                <v-skeleton-loader class="mb-4" type="card"></v-skeleton-loader>
                <v-skeleton-loader class="mb-4" type="card"></v-skeleton-loader>
                <v-skeleton-loader class="mb-4" type="card"></v-skeleton-loader>
              </template>
              <template v-else>
                <news-card
                  :to="'/noticias/' + article.link"
                  :date="article.date"
                  :img="files + article.img"
                  :title="article.title"
                  :text="article.text"
                ></news-card>
              </template>
            </section>
          </v-carousel-item>
        </v-carousel>
      </template>
    </v-container>

    <h1 class="pt-8 pb-4 lighter center primary--text">FOTOS DA OBRA</h1>
    <section v-if="photos.length" class="photos photosbg pa-4">
      <v-container>
        <div class="gap">
          <div class="photodiv" v-for="(photo, i) in photosok" :key="i">
            <photos
              class="ma-4"
              :to="'/fotos/' + photo.link"
              :img="files + photo.cover"
              :title="photo.title"
              :date="photo.date"
            ></photos>
          </div>
        </div>
      </v-container>
    </section>

    <iframe class="map" :src="map" allowfullscreen aria-hidden="false" tabindex="0"></iframe>

    <div class="bgdourado">
      <v-container>
        <v-row>
          <div class="col-12 col-sm-6">
            <iframe
              v-if="embed"
              width="100%"
              height="400"
              :src="embed"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <div class="col-12 col-sm-6">
            <h1 class="lighter px-4">VÍDEOS</h1>
            <div class="py-4 px-4 repe">
              <div class="videosdiv" v-for="(displvideo, i) in videosok" :key="i">
                <router-link :to="'videos/'+displvideo.link">
                  <h5
                    :class="[i == 0 ? 'bold primary--text' : 'bold white--text']"
                  >{{displvideo.title}}</h5>
                </router-link>
              </div>
              <a href="/videos" class="tdn">
                <h5 class="corcinza urldiv">VEJA +</h5>
              </a>
            </div>
          </div>
        </v-row>
      </v-container>
      <div class="bgprimary"></div>
    </div>

    <v-container>
      <template>
        <v-sheet class="mx-auto pt-6">
          <v-slide-group multiple show-arrows>
            <v-slide-item v-for="(partner, n) in partners" :key="n" class="bannersdiv">
              <banners-card :img="files + partner.img" :title="partner.title"></banners-card>
            </v-slide-item>
          </v-slide-group>
        </v-sheet>
      </template>
    </v-container>

    <v-container>
      <template>
        <v-row>
          <div class="col-12 col-sm-6">
            <h1 class="primary--text">INFORMAÇÕES</h1>
            <h5 class="bold primary--text">(66) 99630-2096</h5>
            <h5
              class="bold primary--text"
            >Escritório Operacional: Av. das Sibipirunas, 3813 - Centro - Sinop/MT</h5>
            <h5
              class="bold primary--text"
            >Escritório Comercial: Av. do Comércio, 615 - Centro - Santa Carmen/MT</h5>
            <h5 class="bold primary--text">abrajas@hotmail.com</h5>

            <div class="redes">
              <ul class="d-flex">
                <v-btn
                  class="my-2"
                  v-for="(s, i) in social"
                  :key="i"
                  :href="s.link"
                  :title="s.link"
                  icon
                  fab
                  small
                >
                  <v-icon class="dourado">{{ s.icon }}</v-icon>
                </v-btn>
              </ul>
            </div>

            <div class>
              <img class="logo_footer my-10" src="/img/logo.png" contain height="100%" />
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <h1 class="primary--text">FALE CONOSCO</h1>
            <registration-form class="mb-4 mb-md-0" :action="server + '/sendEmail'"></registration-form>
          </div>
        </v-row>
      </template>
    </v-container>
  </div>
</template>

<script>
import Photos from "../components/Photos";
import NewsCard from "../components/NewsCard";
import BannersCard from "../components/BannersCard";
import RegistrationForm from "../components/RegistrationForm";

import { mapState } from "vuex";

export default {
  data: () => ({
    video: null
  }),
  computed: {
    server() {
      return this.$store.state.server;
    },
    files() {
      return this.$store.state.files + "/";
    },
    articlesok() {
      let articles = this.$store.state.articles;
      return articles && articles.slice(0, 6);
    },
    photosok() {
      let photos = this.$store.state.photos;
      return photos && photos.slice(0, 4);
    },
    videosok() {
      let videos = this.$store.state.videos;
      return videos && videos.slice(0, 3);
    },
    partners() {
      let partners = this.$store.state.partners;
      return partners && partners.slice(0, 8);
    },
    map() {
      return this.$store.state.holder.map;
    },
    social() {
      return this.$store.state.holder.social;
    },
    embed() {
      if (!this.videos) return "";

      const url = new URL(this.videos[0].video);
      let code;
      switch (url.host) {
        case "www.youtube.com":
          code = url.searchParams.get("v");
          break;
        case "youtu.be":
          code = url.pathname.replace(/\/(.+)\/?.*/, "$1");
          break;
      }
      return "https://www.youtube.com/embed/" + code;
    },
    ...mapState(["slides", "photos", "videos", "partners"])
  },
  beforeCreate() {
    this.$store.dispatch("getAllSlides");
    this.$store.dispatch("getAllVideos");
    this.$store.dispatch("getAllPhotos");
    this.$store.dispatch("getAllArticles");
    this.$store.dispatch("getAllPartners");
  },
  components: {
    Photos,
    NewsCard,
    BannersCard,
    RegistrationForm
  },
  methods: {
    openFile(file) {
      window.open(file);
    }
  }
};
</script>

<style>
.carddow img {
  display: inline-block;
  max-width: 150px;
  padding: 10px;
}
.home-logo-xs {
  top: 50px;
  z-index: 4;
  width: 100%;
  padding: 70px;
  filter: drop-shadow(1px 1px 1px #00000088);
}

.carousel-img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.videos {
  display: grid;
  grid-template-columns: 12fr 13fr 12fr;
  gap: 20px;
  grid-auto-rows: max-content;
  justify-content: space-between;
  align-items: center;
}

.photodiv {
  display: inline-block;
}

.news {
  width: 100%;
  padding: 10px;
}

.logo_footer {
  max-width: 100%;
}
.gap {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}
.photosbg {
  background: #475154;
  box-shadow: 0 3px 23px;
}

.dourado {
  color: #e1b768 !important;
}

@media screen and (min-width: 600.001px) and (max-width: 960px) {
  .treatments {
    grid-template-columns: 1fr 1fr;
  }
  .gap {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media screen and (max-width: 600px) {
  .about,
  .nutrology,
  .videos,
  .treatments {
    grid-template-columns: 1fr;
  }
  .nutrology > img {
    height: auto;
  }
  .gap {
    grid-template-columns: repeat(1, 1fr);
  }
}
@media (max-width: 960px) {
  .bgprimary {
    display: none;
  }
}
.videosdiv {
  padding: 20px 0;
  border-bottom: 1px solid #fff;
}
.videosdiv:last-child {
  border: 0;
}
.videosdiv a {
  text-decoration: none;
}
.map {
  width: 100%;
  height: 400px;
  margin-bottom: -6px;
  border: none;
  border-top: 1px solid #ccc;
}
.bgdourado {
  background: #e2b862;
  position: relative;
  z-index: 1;
  box-shadow: 0 0px 20px #485155;
}
.bgprimary {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 50%;
  height: 100%;
  background-color: #485155;
  z-index: -1;
}
.corcinza {
  color: #475154;
  font-weight: bold;
  margin: 20px 0;
}
.tdn {
  text-decoration: none;
}
.redes > ul {
  padding-left: 0 !important;
}
.bannersdiv {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 330px;
  grid-template-rows: 180px;
}
.bannersdiv img {
  max-width: 100%;
}

@media screen and (max-width: 600px) {
  .bannersdiv {
    grid-auto-columns: calc(100vw - 160px);
    grid-template-rows: 120px;
  }
  .article {
    height: auto !important;
  }
  .article .v-carousel__item {
    height: auto !important;
  }
  .slideprincipal {
    height: 180px !important;
  }
  .slideprincipal .v-carousel__item {
    height: 180px !important;
  }
}
</style>